module.exports = __webpack_public_path__ + "img/青岛银行.fd9533c7.png";